import * as LoginActions from './actions';

const initialState = {
  isInitialLogin: null,
  loginResult: false,
  loginTried: false,
  userId: null,
  blockTxHash: null,
  accountChanged: 0,
  willCommit: false,
  committing: false,
  granting: false,
  completed: false,
  progress: 0,
  savedStackId: null
}

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case LoginActions.LOGIN_INITIALIZED: {
      return {
        ...state,
        isInitialLogin: true
      }
    }
    case LoginActions.LOGIN_TRIED: {
      return {
        ...state,
        isInitialLogin: false,
        loginResult: action.loginResult,
        loginTried: true,
        userId: action.userId
      }
    }
    case LoginActions.LOGIN_INITPAGE: {
      return {
        ...state,
        isInitialLogin: false,
        loginResult: false,
        loginTried: false
      }
    }
    case LoginActions.SIGNUP_GRANTING: {
      return {
        ...state,
        granting: true,
        completed: false,
        progress: 1,
        savedStackId: action.savedStackId
      }
    }
    case LoginActions.BLOCK_RECEIVED: {
      return {
        ...state,
        blockTxHash: action.blockHeader.transactionsRoot
      }
    }
    case LoginActions.SIGNUP_GRANTED: {
      return {
        ...state,
        granting: false,
        progress: 2,
        savedStackId: null
      }
    }
    case LoginActions.SIGNUP_WILL_COMMIT: {
      return {
        ...state,
        willCommit: true,
      }
    }
    case LoginActions.SIGNUP_COMMITTING: {
      return {
        ...state,
        committing: true,
        completed: false,
        progress: 3,
        savedStackId: action.savedStackId
      }
    }
    case LoginActions.SIGNUP_COMMITTED: {
      return {
        ...state,
        accountChanged: 0,
        willCommit: false,
        committing: false,
        progress: 4,
        savedStackId: null
      }
    }
    case LoginActions.SIGNUP_COMMIT_COMPLETE: {
      return {
        ...state,
        completed: true
      }
    }
    case LoginActions.SIGNUP_CONFIGURATION_COMPLETE: {
      return {
        ...state,
        completed: false
      }
    }
    case LoginActions.ACCOUNTS_CHANGED: {
      return {
        ...state,
        accountChanged: 1
      }
    }
    case LoginActions.ACCOUNTS_RECOVERED: {
      return {
        ...state,
        accountChanged: 2
      }
    }
    case LoginActions.PATHNAME_CHANGED: {
      return {
        ...state,
        pathname: action.pathname
      }
    }
    default: {
      return state;
    }
  }
}

export default loginReducer;
